const $ = require('jquery');
require('select2');
import {fuzzySearch} from 'tagwalk-api-client/assets/js/common/fuzzySearch';
const filterType = $('#type');
const filterCategory = $('#category');
const filterCity = $('#city');
const filterSeason = $('#season');
const filterDesigner = $('#designer');
const filterTags = $('#tags');
const filterModel = $('#model');
const filterTagIcon = $('.filter-tags .fa-search');
const lang = document.documentElement.lang;

const initFilters = () => {
    let query,
        results;

    filterType.select2({
        allowClear: true,
        placeholder: filterType.attr('data-placeholder')
    });
    filterType.on('change.select2', filterChange);

    filterCategory.select2({
        allowClear: true,
        placeholder: filterCategory.attr('data-placeholder')
    });
    filterCategory.on('change.select2', filterChange);

    filterCity.select2({
        allowClear: true,
        placeholder: filterCity.attr('data-placeholder')
    });
    filterCity.on('change.select2', filterChange);

    filterSeason.select2({
        allowClear: true,
        placeholder: filterSeason.attr('data-placeholder')
    });
    filterSeason.on('change.select2', filterChange);

    filterTags.select2({
        placeholder: filterTags.attr('data-placeholder'),
        minimumInputLength: filterTags.attr('data-minimum') || 0,
        ajax: {
            url: filterTags.attr('data-path'),
            dataType: 'json',
            delay: 300,
            data: function (params) {
                return  {
                    search: params.term,
                    page: params.page || 1,
                    language: lang
                };
            },
            processResults: function (data, params) {
                // Transforms the top-level key of the response object from 'items' to 'results'
                let results = [];

                for (let i = 0; i < data.results.length; i++) {
                    results[i] = {
                        id: data.results[i]['slug'],
                        text: data.results[i]['suggest'].join(' / ')
                    }
                }

                params.page = params.page || 1;

                return {
                    results: results,
                    pagination: {
                        more: (params.page * 10) < data['total_count']
                    }
                };
            }
        }
    });

    filterTags.on('change.select2', (e) => {
        if (!!e.target.value) {
            filterChange(e);
        }
    });

    if (filterTags.length && filterTags.val().length > 0) {
        filterTagIcon.addClass('d-none');
    }

    filterTagIcon.on('click', () => {
        filterTags.select2('open');
    })

    filterDesigner.select2({
        allowClear: true,
        placeholder: filterDesigner.attr('data-placeholder'),
        matcher: fuzzySearch
    });
    filterDesigner.on('change.select2', filterChange);

    if (filterModel.attr('data-path')) {
        filterModel.select2({
            placeholder: filterModel.attr('data-placeholder'),
            minimumInputLength: filterModel.attr('data-minimum'),
            allowClear: true,
            ajax: {
                delay: 300,
                url: filterModel.attr('data-path'),
                dataType: 'json',
                data: function (params) {
                    query = {
                        model: true,
                        search: params.term,
                        page: params.page || 1
                    };
                    return query;
                },
                processResults: function (data, params) {
                    results = [];
                    for (let i = 0; i < data.results.length; i++) {
                        results[i] = {
                            id: data.results[i].slug,
                            text: data.results[i].name.toUpperCase()
                        }
                    }
                    params.page = params.page || 1;
                    return {
                        results: results,
                        pagination: {
                            more: (params.page * 10) < data.total_count
                        }
                    };
                }
            }
        });
    } else {
        filterModel.select2({
            placeholder: filterModel.attr('data-placeholder'),
            minimumInputLength: filterModel.attr('data-minimum'),
            allowClear: true
        });
    }
    filterModel.on('change.select2', filterChange);

    $('form.filters').on('submit', function () {
        $(this).find('select, input').each(function () {
            if (!$(this).val()) {
                $(this).prop('disabled', true);
            }
            addSessionStorage($(this).attr('id'), $(this).val(), $(this).find('option:selected').text());
        })
    });
    invalidFilter();
};

function addSessionStorage(id, value, text) {
    sessionStorage.setItem('filter-' + id, JSON.stringify({
        'id': id,
        'value': value,
        'text': text
    }));
}

function filterChange() {
    $('input#page').val('1');
    $('form.filters').trigger('submit');
    $('.filter').find('select, input').prop('disabled', true);
}

function invalidFilter() {
    let filter = $('.filter');
    filter.each(function() {
        if ($(this).hasClass('is-invalid')) {
            let target = $(this).attr('class').split(' ')[1];
            let result = JSON.parse(sessionStorage.getItem(target));
            $(this).find('#' + result['id']).append($('<option>', {
                value: result['value'],
                text: result['text'],
            })).val(result['value']);
        }
    });
}

export {initFilters};
